@if (!data.disableDialogClose) {
<button
    mat-icon-button
    class="confirm-dialog-close-button"
    [mat-dialog-close]="CancelResult"
>
    <mat-icon>close</mat-icon>
</button>
}
<div class="mat-typography d-flex justify-space-between align-start flex-gap-5">
    <div class="d-flex align-center">
        <span class="ds-icon ds-icon-terms-and-conditions fs-50"></span>
        <div>
            @if (currentStep === steps.TC) {
            <div class="title {{ data.className }} fs-18">
                {{ data.title }}
            </div>
            } @if (currentStep === steps.BREACH) {
            <div class="title {{ data.className }} fs-18">Breach Warranty Terms and Conditions</div>
            }
            <div class="fs-10 last-updated">Last updated: March 2023</div>
        </div>
    </div>
</div>

<mat-dialog-content
    [ngClass]="{ 'm-t-20': showProgressBar, 'm-t-2': !showProgressBar }"
    class="mat-typography"
>
    @if (currentStep === steps.TC) {
    <p>
        <br />
        Please read and accept the
        <a
            target="_blank"
            href="{{ tcUrl }}"
        >
            Terms and Conditions</a
        >
        to proceed with the MDR Portal for yourself. If you encounter any difficulties, @if (isPremium()) {
        <a href="mailto: cst@bitdefender.com">contact us</a>. } @else { <a href="mailto: b2b-support@bitdefender.com">contact us </a>. }
    </p>
    }
</mat-dialog-content>

<mat-dialog-actions
    [ngClass]="{ 'flex-row': !data.stackButtonsVertically, 'flex-column-reverse': data.stackButtonsVertically }"
    class="flex-start-start flex-gap-16"
>
    <div class="d-flex justify-space-between w-100">
        <div
            *appShowSpinner="isLoading"
            id="primary-button-confirm-dialog"
        >
            <button
                (click)="acceptTc()"
                [disabled]="isLoading"
                color="primary"
                mat-flat-button
            >
                Accept
            </button>
        </div>
        @if (currentStep === steps.TC) {
        <button
            id="cancel-button-confirm-dialog"
            mat-stroked-button
            [disabled]="isLoading"
            (click)="declineTc()"
        >
            Decline
        </button>
        }
    </div>
</mat-dialog-actions>
